import React, {useEffect, useState} from "react";
import {Button, Col, ControlLabel, FormGroup, Label, Row} from "react-bootstrap";

import Box from "../../component/Box/Box";
import Notify from "../../services/Notify";
import Loading from "../../component/Loading/Loading";
import NodeService from "./NodeService";
import CompanySelector from "../../component/Company/CompanySelector";
import UserService from "../../services/UserService";
import NodeTypeSelector, {NODE_TYPES} from "./NodeTypeSelector";
import {InputWithLabel} from "../../component/Form/InputWithLabel";
import {InputMaskedIpAddress} from "./InputMaskedIpAddress";
import GatewaySelector, {mapItems} from "../component/GatewaySelector";

function NodesForm({match, history}) {
    const [showCompany, setShowCompany] = useState(UserService.isSuper());
    const [entity, setEntity] = useState({antennas: []});
    const [message, setMessage] = useState(null);
    const [isLoadingEntity, setIsLoadingEntity] = useState(false);

    const nodeService = new NodeService();
    const submitForm = async (event) => {
        try {
            event.preventDefault();
            const type = entity.nodeType || entity.node.nodeType || entity.node.type;
            const node = {
                version: entity.node && entity.node.version || entity && entity.version || 0,
                company: entity.company ? {id: entity.company.id} : UserService.getCompanyId(),
                friendlyName: entity.friendlyName || entity.node.friendlyName,
                type: entity.nodeType || entity.node.nodeType || entity.node.type,
                antennas: (type === NODE_TYPES.RFID || type === NODE_TYPES.EVEN_READER) && (entity.antennas || entity.node.antennas),
                minimumTimeInSecondsBetweenStartAndStop:  entity.minimumTimeInSecondsBetweenStartAndStop || entity.node.minimumTimeInSecondsBetweenStartAndStop ,
                minDbCanSendRead: entity.minDbCanSendRead || entity.node.minDbCanSendRead  ,
                id: entity && entity.node && entity.node.id || entity && entity.id,
            };
            if (entity.nodeType === NODE_TYPES.EVEN_READER) {
                node.ip = entity.ip || entity.node.ip;
                node.port = entity.port || entity.node.port;
            }
            const gateway = entity.gateway;

            const nodeDto = {
                gateway: gateway,
                node
            };
            await nodeService.save(nodeDto);
            history.goBack();
            Notify.success('Entidade salva');
        } catch (error) {
            Notify.error('Falha ao salvar entidade:', error);
        }
    }
    const getNodeById = async (nodeId) => {
        try {
            const entity = await nodeService.findById(nodeId);
            console.log('getNodeById', entity)
            setEntity({node:entity});
        } catch (error) {
            throw error;
        }
    };

    const getNodeByIdV2 = async (nodeId) => {
        try {
            setIsLoadingEntity(true);
            const entity = await nodeService.findByIdV2(nodeId);
            console.log('getNodeByIdV2', entity)
            setEntity(entity);
        } catch (error) {
            await getNodeById(nodeId);
        } finally {
            setIsLoadingEntity(false);
        }
    };

    const setEntityProperty = (property, value) => {
        setEntity({...entity, [property]: value})
    }

    const fetchEntity = async (id) => {
        try {
            await getNodeByIdV2(id);
        } catch (error) {
            try {

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setMessage("Entidade não encontrada!");
                } else {
                    setMessage("Erro inesperado!");
                    Notify.error('Falha ao buscar entidade!', error);
                }
            }
        }
    };
    useEffect(() => {
        const id = match.params.id;
        if (id) {
            fetchEntity(id);
        }
    }, [match.params.id]);

    const AntennasForm = () => {
        const antennasCount = [1, 1, 1, 1]

        const handleSetAntennaProperty = (property, value, index) => {
            entity.antennas = entity.antennas ? entity.antennas : [];
            entity.antennas[index] = {
                ...entity.antennas[index],
                [property]: value
            }
            setEntity(entity)
        }
        return (
            <Row>
                {antennasCount.map((x, index) => (
                    <React.Fragment key={index}>
                        <Col md={12}>
                            <Label>{`Antena ${index + 1}`}</Label>
                        </Col>
                        <Col md={12}>
                            <InputWithLabel
                                required
                                label="UUID"
                                inputType="text"
                                defaultValue={entity && entity.node && entity.node.antennas && entity.node.antennas[index] && entity.node.antennas[index].uuid ||
                                    entity && entity.antennas && entity.antennas[index] && entity.antennas[index].uuid}
                                onChangeText={e => handleSetAntennaProperty('uuid', e, index)}
                            />
                            <InputWithLabel
                                required
                                label="Potência"
                                inputType="number"
                                max={entity.nodeType === NODE_TYPES.EVEN_READER ? "30" : "300"}
                                onlyNumbers
                                defaultValue={entity && entity.node && entity.node.antennas && entity.node.antennas[index] && entity.node.antennas[index].potency ||
                                    entity && entity.antennas && entity.antennas[index] && entity.antennas[index].potency}
                                onChangeText={e => handleSetAntennaProperty('potency', e, index)}
                            />
                            <InputWithLabel
                                required
                                label="Ciclo"
                                inputType="number"
                                onlyNumbers
                                defaultValue={entity && entity.node && entity.node.antennas && entity.node.antennas[index] && entity.node.antennas[index].cycle ||
                                    entity && entity.antennas && entity.antennas[index] && entity.antennas[index].cycle}
                                onChangeText={e => handleSetAntennaProperty('cycle', e, index)}
                            />
                            <InputWithLabel
                                required
                                label="Intervalo da tag"
                                inputType="number"
                                onlyNumbers
                                defaultValue={entity && entity.node && entity.node.antennas && entity.node.antennas[index] && entity.node.antennas[index].timeoutTag ||
                                    entity && entity.antennas && entity.antennas[index] && entity.antennas[index].timeoutTag}
                                onChangeText={e => handleSetAntennaProperty('timeoutTag', e, index)}
                            />
                        </Col>
                        <Col md={12}>
                            <hr/>
                        </Col>
                    </React.Fragment>
                ))}
            </Row>
        )
    }
    if (isLoadingEntity) {
        return <Loading/>
    }

    if (message) {
        return <h2>{message}</h2>
    }
    return (
        <Box info>
            <form onSubmit={submitForm}>
                <FormGroup>
                    <ControlLabel>Nome</ControlLabel>
                    <input type="text" className="form-control" placeholder="Nome"
                           required
                           name="friendlyName"
                           onChange={e => setEntityProperty("friendlyName", e.target.value)}
                           defaultValue={entity && entity.node && entity.node.friendlyName || entity.friendlyName}/>
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Uuid</ControlLabel>
                    <input disabled={true} type="text" className="form-control"
                           placeholder="uuid"
                           required
                           name="uuid"
                           defaultValue={entity.node && entity.node.uuid}/>
                </FormGroup>

                {showCompany &&
                    <CompanySelector
                        defaultValue={entity.company && entity.company.id}
                        setValue={companyId => setEntityProperty('companyId', companyId)}/>}

                {entity.id || entity.node && entity.node.id ?
                    <NodeTypeSelector defaultValue={entity && entity.type || entity.node && entity.node.type}
                                      setValue={
                                          nodeType => setEntityProperty('nodeType', nodeType)}/> :
                    <NodeTypeSelector defaultValue={NODE_TYPES.EVEN_READER}
                                      readonly={!(entity && entity.node && entity.node.id)}
                                      setValue={nodeType => setEntityProperty('nodeType',
                                          entity && entity.node && entity.node.id ? nodeType : NODE_TYPES.EVEN_READER)}/>

                }
                {entity.nodeType === NODE_TYPES.RFID || entity.node && entity.node.type === NODE_TYPES.RFID && (
                    <Row>
                        <Col md={12}>
                            <InputWithLabel
                                required
                                label="Tempo mínimo entre START e STOP para gerar evento"
                                inputType="number"
                                onlyNumbers
                                defaultValue={entity.node.minimumTimeInSecondsBetweenStartAndStop || 0}
                                onChangeText={e => setEntityProperty("minimumTimeInSecondsBetweenStartAndStop", e)}
                            />
                            <InputWithLabel
                                required
                                label="Valor mínimo do RSSI para envio de leitura. Exemplo: -50"
                                inputType="number"
                                onlyNumbers
                                min={-90}
                                max={0}
                                defaultValue={entity && entity.node.minDbCanSendRead}
                                onChange={e => setEntityProperty('minDbCanSendRead', e.target.value)}
                            />
                        </Col>
                    </Row>)}
                {entity.nodeType === NODE_TYPES.EVEN_READER && (<Row>
                    <Col md={12}>
                        <InputMaskedIpAddress
                            placeholder="Digite um IP"
                            title="Endereço IP"
                            defaultValue={entity && entity.node && entity.node.ip}
                            onChangeText={e => setEntityProperty("ip", e)}
                        />
                        <GatewaySelector
                            onChange={value => setEntityProperty('gateway', value)}
                            defaultValue={entity && entity.gateway && mapItems(entity.gateway)}
                        />
                        <InputWithLabel
                            required
                            label="Porta"
                            inputType="number"
                            onlyNumbers
                            defaultValue={entity && entity.node && entity.node.port || 0}
                            onChange={e => setEntityProperty('port', e.target.value)}
                        />
                        <AntennasForm/>
                    </Col>
                </Row>)}
                {entity.nodeType === NODE_TYPES.RFID || entity.node && entity.node.type === NODE_TYPES.RFID && (
                    <AntennasForm/>)}
                <div className="row" style={{marginRight: 0}}>
                    <div className="pull-right">
                        <Button className="btn btn-default"
                                onClick={() => history.goBack()}>Cancelar</Button>
                        <Button type="submit" bsStyle="success">Salvar</Button>
                    </div>
                </div>
            </form>
        </Box>);
}

export default NodesForm;



// WEBPACK FOOTER //
// ./src/gateways/node/NodesForm.js